/**
 * Rodzaj segmentu ceny. 'value' - kwotowy, 'percent' - procentowy, 'multiplier' - mnożnik
 */
type PriceSegmentType = 'value' | 'percent' | 'multiplier';
/**
 * Segment ceny
 *
 * @export
 * @interface PriceSegment
 */
export type PriceSegment = {
    /**
     * Id segmentu ceny
     */
    id?: number;
    /**
     * Rodzaj segmentu ceny.
     *
     * - 'value' - kwotowy
     * - 'percent' - procentowy
     * - 'multiplier' - mnożnik
     */
    valueType: 'percent' | 'multiplier' | 'multiplierAfterPercent';
    /**
     * Rodzaj ceny (czego cena dotyczy).
     */
    type: string;
    /**
     * Wartość bazowa (niezmienna później)
     *
     */
    baseValue: number | null;
    /**
     * Wartość - przeliczana przez procenty.
     */
    value: number | null;
    /**
     * Dodatkowe dane segmentu
     */
    data : any;
    /**
     * Do których segmentów ma być doliczany procent.
     *
     */
    to?  : string | number | (string | object | any)[];
} | {
    /**
     * Id segmentu ceny
     */
    id?: number;
    /**
     * Rodzaj segmentu ceny.
     *
     * - 'value' - kwotowy
     * - 'percent' - procentowy
     * - 'multiplier' - mnożnik
     */
    valueType: 'value';
    /**
     * Rodzaj ceny (czego cena dotyczy).
     */
    type: string;
    /**
     * Wartość bazowa (niezmienna później)
     */
    baseValue: number | null;
    /**
     * Wartość - przeliczana przez procenty.
     */
    value: number | null;
    /**
     * Ilość
     */
    quantity?: number;

    /**
    * Waluta w postaci kodu zgodnego ze standardem ISO 4217
    */
    valueCurrency?: string;
    /**
     * Stawka podatku VAT
     */
    taxRate?: number;

    /**
     * Czy kwota jest brutto?
     */
    valueIsGross?: boolean;
    /**
     * Dodatkowe dane segmentu
     */
    data: any;
    /**
     * Do których segmentów ma być doliczany procent.
     *
     */
    to?  : string | number | (string | object | any)[];
}

export function isValueSegment(segment: PriceSegment): segment is Extract<PriceSegment, { valueType: 'value' }> {
    return segment.valueType === 'value';
}

export function isPercentSegment(segment: PriceSegment): segment is Extract<PriceSegment, { valueType: 'percent' | 'multiplier' }> {
    return segment.valueType === 'percent' || segment.valueType === 'multiplier';
}
